// Vygeneruje čitateľné, dostatočne unikátne číslo rezervácie.
// Web nemá databázu ani backend, preto sa unikátnosť rieši dátumom podania
// + krátkym náhodným kódom (36^4 ≈ 1,68 milióna kombinácií na deň –
// pre počet rezervácií tejto firmy prakticky vylučuje kolíziu).
// Formát: CK-YYMMDD-XXXX, napr. CK-260722-8QF3

export function generateReservationNumber() {
  const now = new Date();
  const y = String(now.getFullYear()).slice(-2);
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const suffix = Math.random().toString(36).slice(2, 6).toUpperCase().padEnd(4, '0');
  return `CK-${y}${m}${d}-${suffix}`;
}
